<template lang="pug">
div.wrap-atom-slider.pt8
  div(:class="{'is-dark': dark}").wrap-head.f.fm.flex-between
    span.block.fz16 {{label}}
    input(ref="input" v-model="inputParam"
      type="number" :step="step"
      @keydown.stop="keydown" @keyup.stop="keyup" @click="onInput").text-right.fz16
  v-slider(v-model="sliderParam"
    :min="min" :max="max" :step="step" :color="color" :dark="dark")
  div(v-if="defaultValue").f.flex-right.mb8
    span(@click="sliderParam = defaultValue").btn-reset.fz12.cursor-pointer リセット
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-atom-slider {
  width: 100%;
  .wrap-head {
    &.is-dark {
      color: $dark_primary_text_color;
    }
    input {
      outline: none;
      color: $active_color;
    }
    // hide stepper
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type=number] {
      -moz-appearance: textfield;
    }
  }
  .btn-reset {
    color: $active_color;
  }
}
</style>

<style lang="scss">
.wrap-atom-slider {
  .v-slider {
    margin: 0 !important;
  }
  .v-messages {
    display: none;
  }
  .v-input__slot {
    margin: 0;
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    defaultValue: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      default: '#fff'
    },
    dark: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disableMinus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sliderParam: 0,
      inputParam: 0,
      shiftIsPressed: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    // param () {
    //   this.$emit('input', Number(this.param))
    // },
    sliderParam () {
      if (this.sliderParam !== '') {
        this.$emit('input', Number(this.sliderParam))
        this.inputParam = Number(this.sliderParam)
      }
    },
    inputParam () {
      if (this.inputParam !== '') this.$emit('input', Number(this.inputParam))
    },
    value () {
      this.sliderParam = this.value
      this.inputParam = this.value
    }
  },
  async created () {
    this.sliderParam = this.value
    this.inputParam = this.value
  },
  methods: {
    keydown (e) {
      if (['Shift'].includes(e.key)) this.shiftIsPressed = true
      if (['ArrowUp'].includes(e.key)) {
        e.preventDefault()
        this.inputParam += this.shiftIsPressed ? this.step * 10 : this.step
      }
      if (['ArrowDown'].includes(e.key)) {
        e.preventDefault()
        if (this.disableMinus) {
          const decrement = this.shiftIsPressed ? this.step * 10 : this.step
          if ((this.inputParam - decrement) < 0) return
        }
        this.inputParam -= this.shiftIsPressed ? this.step * 10 : this.step
      }
      if (this.inputParam > this.max) {
        this.sliderParam = this.max
      } else if (this.inputParam < this.min) {
        this.sliderParam = this.min
      } else {
        this.sliderParam = this.inputParam
      }
    },
    keyup (e) {
      if (['Shift'].includes(e.key)) this.shiftIsPressed = false
    },
    onInput () {
      this.$refs.input.select()
    }
  }
}
</script>
